import { T, TF } from "react-translator-component";
import TableComponent from "../GreenCity/TableComponent";
import { Box, Typography } from "@mui/material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import dayjs from "../../util/dayjs";
import GroupIcon from "../GreenCity/GroupIconImage";

interface Props {
  post: any;
  applier: any;
  paymentDetails?: any[];
}

export default function RefundEventApplicationDetail({
  post,
  applier,
  paymentDetails = [],
}: Props) {
  const formatEventDate = (start_date: any, end_date: any) => {
    const startDate = dayjs(start_date);
    const endDate = dayjs(end_date);

    if (startDate.isSame(endDate, "day")) {
      // If start and end dates are the same
      return startDate.format("YYYY年M月D日(ddd)");
    } else {
      // If start and end dates are different
      return `${startDate.format("YYYY年M月D日(ddd)")}~${endDate.format(
        "M月D日(ddd)"
      )}`;
    }
  };

  return (
    <Box>
      <Box sx={styles.groupLabel}>
        <GroupIcon
          groupId={post?.member_group?.id}
          style={styles.groupIconImage}
        />
        <Typography>{post?.member_group?.name}</Typography>
      </Box>

      <Box component="div" style={styles.topButtonContainer}>
        <CalendarMonthIcon
          style={styles.calendarIcon}
        />
        <Typography style={styles.eventPaymentDetails}>
          {T("event_payment_details")}
        </Typography>
      </Box>

      <Box sx={styles.container}>
        <TableComponent
          data={[
            {
              col1: T("host"),
              col2: (
                <Box sx={styles.host}>
                  <GroupIcon
                    groupId={post?.member_group?.id}
                    style={styles.hostIconImage}
                  />
                  <Typography>{post?.member_group?.name}</Typography>
                </Box>
              ),
            },
            {
              col1: T("event_name"),
              col2: post?.title,
            },
            {
              col1: T("event_date"),
              col2: (
                <Box>
                  <Typography>
                    {post?.post_events?.length > 0 &&
                      formatEventDate(
                        post.post_events[0].start_date,
                        post.post_events[0].end_date
                      )
                    }
                  </Typography>
                </Box>
              ),
            },
          ]}
        />
      </Box>

      <Box sx={styles.container}>
        {paymentDetails.length > 0 && (
          <>
            <Typography sx={styles.applicationSubjectTitle}>
              {T("event_payment_details_application_subject")}
            </Typography>

            {paymentDetails.map((detail: any, index: number) => (
              <Box
                key={index}
                sx={styles.applicationSubjectList}
              >
                <TableComponent
                  data={[
                    {
                      col1: T("subject"),
                      col2: detail?.name,
                    },
                    {
                      col1: T("entry_fee"),
                      col2: TF("{0} {1}{2}", T("per_person"), Number(detail?.fee_amount), T("unit_yen")),
                    },
                    {
                      col1: T("number_of_entering_person"),
                      col2: detail?.number_of_participants,
                    },
                    {
                      col1: T("event_payment_details_sum_of_entry_fee"),
                      col2: detail?.total_amount,
                    },
                  ]}
                />
              </Box>
            ))}

            <TableComponent
              data={[
                {
                  col1: T("required_amount"),
                  col2: paymentDetails?.reduce(
                    (sum: number, item: any) => sum + item?.total_amount,
                    0
                  ),
                },
              ]}
            />

            <Typography sx={styles.applierTitle}>
              {T("applier")}
            </Typography>
            <TableComponent
              data={[
                {
                  col1: T("nickname"),
                  col2: applier?.nickname,
                },
              ]}
            />
          </>
        )}
      </Box>
    </Box>
  );
};

const styles = {
  topButtonContainer: {
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
    marginTop: 10,
  },
  groupLabel: {
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
    gap: 1,
  },
  groupIconImage: {
    width: 30,
    height: 30,
    borderRadius: "50%"
  },
  hostIconImage: {
    width: 25,
    height: 25,
    borderRadius: "50%"
  },
  calendarIcon: {
    borderWidth: 1,
    width: 26,
    height: 26,
    padding: 2,
    margin: 2,
  },
  eventPaymentDetails: {
    marginTop: 4
  },
  container: {
    marginTop: 4
  },
  host: {
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
    gap: 1,
  },
  applicationSubjectTitle: {
    borderBottom: "2px solid #86BB57",
    marginTop: "10px",
    marginBottom: "10px",
    textAlign: "left",
    fontSize: "15px",
  },
  applicationSubjectList: {
    paddingBottom: "20px"
  },
  applierTitle: {
    borderBottom: "2px solid #86BB57",
    paddingTop: "20px",
    marginBottom: "10px",
    textAlign: "left",
    fontSize: "15px",
  }
};
